var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 31,
    viewBox: "0 0 47 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.50665 5.21094H0.686523V30.8604H7.50665V5.21094Z",
    fill: "#4C4C50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1914 0.860413L26.8299 30.8604H19.5556L16.6002 20.5909V30.8604H9.78027V0.860413H18.1914Z",
    fill: "#4C4C50"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1527 0.860413H39.333V30.8604H46.1527V0.860413Z",
    fill: "#4C4C50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2398 20.5909L28.4214 26.9138L24.7842 14.2908L28.6488 0.860413H37.0606V30.8604H30.2398V20.5909Z",
    fill: "#4C4C50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImi);
export default __webpack_public_path__ + "static/media/imi.4e32cd436d33f18536f5801508b11d35.svg";
export { ForwardRef as ReactComponent };